import { createContext } from 'react';

import { DEFAULT_STATUS, MessagingType } from './types';

export const MessagingContext = createContext<MessagingType>({
  status: DEFAULT_STATUS,
});
